import { Routing } from "helpers/routing";
import { createContext } from "react";

const NearestMatchesContext = createContext<{
  params?: Routing.NearestMatchParams
}>({})

export { NearestMatchesContext }
